import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { id: "sobre", label: "Sobre" },
  { id: "servicos", label: "Serviços" },
  { id: "erps", label: "ERPs" },
  { id: "metodo", label: "Metodologia" },
  { id: "academy", label: "Academy" },
  { id: "resultados", label: "Resultados" },
  { id: "faq", label: "FAQ" },
];

const LOGO_URL =
  "/ponzena-logo.png";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#030B1E]/80 border-b border-cyan-400/15"
          : "bg-transparent"
      }`}
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-24 md:h-28 flex items-center justify-between">
        <button
          onClick={() => scrollTo("hero")}
          className="flex items-center group"
          data-testid="nav-logo"
        >
          <img
            src={LOGO_URL}
            alt="Ponzena - Transformação Digital para Empresas"
            className="h-14 md:h-16 lg:h-[70px] w-auto object-contain transition-all group-hover:drop-shadow-[0_0_18px_rgba(0,229,255,0.55)]"
          />
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="px-4 py-2 text-sm text-[#B8C0D0] hover:text-white transition-colors relative group"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
              <span className="absolute left-4 right-4 bottom-1 h-px bg-cyan-400 scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => scrollTo("contato")}
            className="hidden md:inline-flex btn-primary text-sm py-2.5 px-5"
            data-testid="nav-cta"
          >
            Agendar Diagnóstico
          </button>
          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden text-white p-2"
            data-testid="nav-mobile-toggle"
            aria-label="Menu"
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#030B1E]/95 border-t border-cyan-400/15" data-testid="nav-mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-1">
            {LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => scrollTo(l.id)}
                className="text-left py-3 px-2 text-[#B8C0D0] hover:text-cyan-400"
                data-testid={`nav-mobile-link-${l.id}`}
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => scrollTo("contato")}
              className="btn-primary mt-3 justify-center"
              data-testid="nav-mobile-cta"
            >
              Agendar Diagnóstico
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
